module.exports = __webpack_public_path__ + "img/logo-lfv.312214eb.jpg";